import React, { useEffect, useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { WHATSAPP_DIGITS } from "../data/designOptions";

const NAV = [
  { id: "visualize", label: "Visualize" },
  { id: "services", label: "Services" },
  { id: "portfolio", label: "Portfolio" },
  { id: "process", label: "Process" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 md:px-12">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          data-testid="logo-btn"
          className="group flex items-baseline gap-2"
        >
          <span className="font-[Cormorant_Garamond] text-2xl font-medium tracking-tight text-[#F7F5F0]">
            Design<span className="italic text-[#B8996F]">decor</span>
          </span>
          <span className="hidden text-[10px] uppercase tracking-[0.28em] text-white/45 sm:inline">
            · Hubballi
          </span>
        </button>

        <nav className="hidden items-center gap-7 md:flex" data-testid="primary-nav">
          {NAV.map((n) => (
            <button
              key={n.id}
              type="button"
              onClick={() => go(n.id)}
              data-testid={`nav-${n.id}`}
              className="text-[11px] uppercase tracking-[0.22em] text-white/70 transition-colors duration-300 hover:text-white"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={`https://wa.me/${WHATSAPP_DIGITS}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-btn"
            className="hidden items-center gap-2 border border-[#B8996F] px-4 py-2 text-[11px] uppercase tracking-[0.22em] text-[#B8996F] transition-colors duration-300 hover:bg-[#B8996F] hover:text-[#0A0A0A] md:inline-flex"
          >
            <MessageCircle size={14} strokeWidth={1.8} /> WhatsApp
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
            className="p-2 text-white/85 md:hidden"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#0A0A0A]" data-testid="mobile-menu">
          <div className="flex flex-col px-6 py-4">
            {NAV.map((n) => (
              <button
                key={n.id}
                type="button"
                onClick={() => go(n.id)}
                data-testid={`mobile-nav-${n.id}`}
                className="border-b border-white/10 py-3 text-left text-[12px] uppercase tracking-[0.22em] text-white/80"
              >
                {n.label}
              </button>
            ))}
            <a
              href={`https://wa.me/${WHATSAPP_DIGITS}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-btn"
              className="mt-4 flex items-center justify-center gap-2 bg-[#B8996F] px-4 py-3 text-[11px] uppercase tracking-[0.22em] text-[#0A0A0A]"
            >
              <MessageCircle size={14} /> WhatsApp Quick Connect
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
